import { ComponentProps } from 'react';
import ReactVisibilitySensor from 'react-visibility-sensor';

import useIsAfterHydration from '../../../../hooks/use-is-after-hydration';

type ReactVisibilitySensorProps = ComponentProps<typeof ReactVisibilitySensor>;

const ServerSafeVisibilitySensor = ({ children, ...props }: ReactVisibilitySensorProps) => {
  const isAfterHydration = useIsAfterHydration();

  // On server/SSR, just pass through children without the sensor wrapper
  if (!isAfterHydration) {
    return children;
  }

  // On client, use the full sensor
  return <ReactVisibilitySensor {...props}>{children}</ReactVisibilitySensor>;
};

export default ServerSafeVisibilitySensor;
